<template>
  <header>
    <v-app-bar app color="white" flat class="responsive-bar">
      <img
        v-if="$vuetify.display.mdAndUp"
        src="/aceapp-logo.png"
        alt="Logo Aceapp"
        class="responsive-image ml-10"
      />
      <img
        v-else
        src="/solo logo.png"
        alt="Logo Aceapp reducido"
        class="responsive-image"
      />

      <v-app-bar-title class="texto">
        <p class="portal">{{ title }}</p>
      </v-app-bar-title>

      <v-spacer v-if="$vuetify.display.mdAndUp"></v-spacer>
      <v-menu :location="location" v-if="this.$store.getters.isAuthenticated">
        <template v-slot:activator="{ props }">
          <v-btn
            prepend-icon="mdi mdi-account-circle-outline"
            v-bind="props"
            v-if="$vuetify.display.mdAndUp"
            color="#244125"
          >
            {{ usuario }}
          </v-btn>
          <v-btn
            v-else
            icon="mdi mdi-account-circle-outline"
            color="#244125"
            v-bind="props"
          >
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>{{ usuario }}</v-list-item-title>
            <v-list-item-title style="color:grey">{{ facturtador }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-if="!(this.$store.getters.getUnicoNivEst) && (esAdminFact())" class="texto" @click="this.$router.push('/auth/eleccion-modo')">
            <v-list-item-title>Cambiar facturador</v-list-item-title>
          </v-list-item>
          <v-list-item class="texto" v-if="!esPacienteExterno()" @click="this.$router.push({ name: 'cambiar-contrasenia', query: { primerLogin: false } });">
            <v-list-item-title>Cambiar contraseña</v-list-item-title>
          </v-list-item>
          <v-list-item class="texto" @click="cerrarSesion" style="background-color: #FF9999;">
            <v-list-item-title>Cerrar sesión</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <a v-else 
      class="my-text-black" 
      style="text-decoration: underline; cursor: pointer;"
      @click="this.$router.push('/auth/login')"
      >
        Iniciar sesión
      </a>
      
      <v-app-bar-nav-icon
        v-if="$vuetify.display.mdAndUp && (esAdminFact() || esAdministrador())"
        class="hamburger-menu mr-10"
        @click="drawer = !drawer"
        color="#244125"
        size="large"
      />
      <v-app-bar-nav-icon
        v-if="!$vuetify.display.mdAndUp && (esAdminFact() || esAdministrador())"
        class="hamburger-menu"
        @click="drawer = !drawer"
        color="#244125"
        size="large"
      />
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      color="rgba(36, 65, 37, 1)"
      image="/register-bg.jpg"
      class="navigation-drawer d-flex flex-column justify-space-between"
      temporary
      location="right"
    >
    <v-list nav v-if="esAdminFact()">
      <v-list-item class="texto" @click="this.$router.push('/cargar-prestacion')">
        <v-list-item-title>Realizar solicitud</v-list-item-title>
      </v-list-item>
      <v-list-item class="texto" @click="this.$router.push('/listado-solicitudes/')">
        <v-list-item-title>Solicitudes cargadas</v-list-item-title>
      </v-list-item>
      <v-list-item class="texto" v-if="!esPoliTandil()" @click="openLink('https://sistemas.ioma.gba.gov.ar/PrestacionesDigitales/User/Login')">
        <v-list-item-title>Receta electrónica</v-list-item-title>
      </v-list-item>
      <!-- <v-list-item class="texto" v-else @click="redirigirRecetaExterna()">
        <v-list-item-title>Receta electrónica</v-list-item-title>
      </v-list-item> -->
      <v-list-item v-if="!esPoliTandil()" @click="openLink('https://sistemas.ioma.gba.gov.ar/FacturacionElectronica/Users/Login/aceapp')" class="texto">
        <v-list-item-title>Facturación IOMA</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="esPoliTandil()" @click="downloadFile(altaCompUrl)" class="texto">
        <v-list-item-title>Descargar planilla Alta Complejidad</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="esPoliTandil()" @click="downloadFile(confUrl)" class="texto">
        <v-list-item-title>Descargar planilla Conformidad</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="esPoliTandil()" @click="this.$router.push('/reporte-diario')" class="texto">
        <v-list-item-title>Generar reporte diario</v-list-item-title>
      </v-list-item>
      <v-list-item class="texto" @click="this.$router.push('/mesa-de-ayuda/')">
        <v-list-item-title>Mesa de ayuda</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-list nav v-if="esAdministrador()">
      <v-list-item class="texto" @click="this.$router.push('/administrador')">
        <v-list-item-title>Carga datos</v-list-item-title>
      </v-list-item>
      <v-list-item class="texto" @click="this.$router.push('/administrador/estadisticas')">
        <v-list-item-title>Estadísticas</v-list-item-title>
      </v-list-item>
    </v-list>
    </v-navigation-drawer>
  </header>
</template>

<style scoped>
#divider {
    color:#254126;
    border-width: 1px;
}
header {
  display: flex;
  align-items: center;
  top: 0;
  border-bottom: 2px #244125 solid;
}
.responsive-image {
  height: 40px;
  margin: auto;
  padding-right: 20px;
  border-right: 2px solid #244125;
}
.hamburger-menu {
  margin: auto;
}
.texto {
  margin: auto;
}
.portal {
  color: #244125;
  font-size: x-large;
  font-weight: bold;
  padding-left: 2%;
}
.navigation-drawer {
  background-color: #244125 !important;
  background-image: url("../../public/register-bg.jpg") !important;
  background-size: cover;
  background-repeat: no-repeat;
}
@media (max-width: 810px) {
  .responsive-image {
    height: 50px;
    margin: auto;
  }
  .portal {
    font-size: medium;
    font-weight: bold;
  }
}
</style>

<script>
import { Role } from "@/_helpers/role";
import { polisTandil } from "@/_helpers/polisTandil";
import ServicioExterno from "@/api/ServicioExterno";
import PrestacionService from "@/api/PrestacionService";

const servicioExterno = new ServicioExterno();
const prestacionService = new PrestacionService();

export default {
  props: {
    title: {
      type: String,
      default: "ATENCIÓN ACEAPP",
    },
  },
  data() {
    return {
      drawer: false,
      facturtador: this.$store.getters.getFacturador.nombre,
    };
  },
  computed: {
    usuario() {
        return this.$store.getters.getUsername;
    },
    altaCompUrl() {
      return `${process.env.VUE_APP_DESCARGA_PLANILLAS}/altaComplejidad.pdf`;
    },
    confUrl() {
      return `${process.env.VUE_APP_DESCARGA_PLANILLAS}/conformidad.pdf`;
    }
  },
  methods: {
    cerrarSesion() {
      this.$store.commit("logout", true);
      this.$router.push("/auth/login");
    },
    esAdminFact() {
      return this.$store.getters.getRole == Role.AdministrativoFacturador;
    },
    esAdministrador(){
      return this.$store.getters.getRole == Role.Administrador;
    },
    esRolAutorizador(){
      return this.$store.getters.getRole == Role.Autorizador;
    },
    esPacienteExterno(){
      return this.$store.getters.getRole == Role.Paciente;
    },
    esFacturadorIoma(){
      return this.$store.getters.getRole == Role.FacturadorIOMA;
    },
    openLink(url) {
      window.open(url, "_blank", "noopener,noreferrer");
    },
    esPoliTandil(){
      return polisTandil.esTandil(this.$store.getters.getFacturador.cuit);
    },
    async downloadFile(filePath) {
      try {
          const response = await fetch(filePath);
          if (!response.ok) throw new Error('Error al obtener el archivo');

          const blob = await response.blob();
          const blobUrl = URL.createObjectURL(blob);

          const fileName = filePath.split('/').pop(); 

          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = fileName;

          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          URL.revokeObjectURL(blobUrl);
      } catch (error) {
          console.error('Error descargando el archivo:', error);
      }
    },
    redirigirRecetaExterna(){
      const profesional = this.$store.getters.getProfesionalUsuario;
      if(profesional){
        const matricula = profesional.matricula;
        const response = servicioExterno.redirigirRecetaElectronica(this.$store.getters.getJwt, matricula);
        if(response && response.status == 200){
          console.log('redireccion exitosa');
        }
      }
    }
  },
};
</script>
